export const iconFontAwesomeNatureTree = (
	<i className="fa-solid fa-tree"></i>
);
